import logo from './logo.svg';
import './App.css';
import { useEffect,useState } from 'react';


import InteractiveVideoOverlay from './intract';

// socket.emit('join', {email: 'matt@ninjatechnolabs.com'});
// socket.on('new_msg', function (sent_to) {
//   console.log(sent_to);
// });
function App() {

 
 
  return (
    <div className="App">
      <header className="App-header">
        
       <InteractiveVideoOverlay/>
       
      </header>
    </div>
  );
}

export default App;
